// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32M8B","col":"styles_col__1dvXZ"};